import { Component, Input } from '@angular/core';

/**
 * Sección de formulario: título con icono en pastilla y separador inferior.
 *
 * Extraído de `shop-settings/shop-info`, la referencia de diseño del backoffice.
 *
 * DOS COSAS QUE NO SE PUEDEN CAMBIAR, y conviene saber por qué antes de tocarlas:
 *
 * 1. La clase del contenedor tiene que seguir llamándose `.form-section`. No es un capricho:
 *    `assets/sass/bootstrap-extended/_forms.scss` y `assets/sass/themes/layout-dark.scss` la
 *    estilizan globalmente como `form .form-section`, y renombrarla desactivaría esas reglas
 *    en las pantallas que sí son formularios.
 *
 * 2. Pero el componente NO exige estar dentro de un `<form>`: resuelve el modo oscuro por su
 *    cuenta con `:host-context(body.layout-dark)`. Se hizo así al integrar la Fase 3, porque
 *    obligar a envolver en un `<form>` una pantalla que no lo es (la de terminales, con sus
 *    interruptores de autoguardado) convierte cada `<button>` sin `type` en un submit que
 *    recarga la página. Un color de borde no justifica ese pie de banco.
 *
 *   <app-section-card title="st_adress" icon="bi bi-geo-alt">
 *     ...campos...
 *   </app-section-card>
 */
@Component({
  selector: 'app-section-card',
  templateUrl: './section-card.component.html',
  styleUrls: ['./section-card.component.scss']
})
export class SectionCardComponent {

  /**
   * Clave i18n del título de la sección. Opcional: sin ella la tarjeta no pinta rótulo y queda
   * como contenedor de campos, que es lo que hace falta cuando la pantalla tiene UNA sola
   * sección y ya la ha titulado alguien de arriba (la cabecera de un modal, por ejemplo).
   */
  @Input() title?: string;

  /** Icono bootstrap, p.ej. 'bi bi-geo-alt'. Sin él no se pinta la pastilla. */
  @Input() icon?: string;

  @Input() titleParams?: Record<string, unknown>;
}
